/* global $ */
/* eslint-disable strict */

function isInputEqual() {
  const newPasswordInput = $('#newPasswordInput');
  const confirmPasswordInput = $('#confirmPasswordInput');
  return newPasswordInput.val() === confirmPasswordInput.val();
}

function passwordHasCorrectLength() {
  const MIN_PASSWORD_LENGTH = 5;
  return $('#newPasswordInput').val().length > MIN_PASSWORD_LENGTH;
}

function addErrorClassToConfirmationInput(isEqual) {
  const confirmPasswordInput = $('#confirmPasswordInput');

  if (isEqual) {
    confirmPasswordInput.removeClass('error');
  } else {
    confirmPasswordInput.addClass('error');
  }
}

function enableResetButton(isEqual) {
  const resetBtn = $('#confirmPasswordResetBtn');
  resetBtn.prop('disabled', !isEqual);

  if (isEqual) {
    resetBtn.removeClass('is-disabled');
  } else {
    resetBtn.addClass('is-disabled');
  }
}

function toggleResetButton() {
  const isPasswordValid = isInputEqual() && passwordHasCorrectLength();
  addErrorClassToConfirmationInput(isPasswordValid);
  enableResetButton(isPasswordValid);
}

function showSpinner() {
  $('#spinnerContainer').append($('<span/>').addClass('mx-spinner-ring'));
}

function hideResetButton() {
  $('#confirmPasswordResetBtn').hide();
}

$('#confirm-password-reset-new-input').click(() => {
  const confirmPassword = $('#confirmPasswordInput');
  const type = confirmPassword.attr('type');

  if (type === 'text') {
    confirmPassword.attr('type', 'password');
  }
  if (type === 'password') {
    confirmPassword.attr('type', 'text');
  }
});

$('#confirmPasswordInput').on('input', () => {
  toggleResetButton();
});

$('#newPasswordInput').on('input', () => {
  toggleResetButton();
});

$('#confirmPasswordResetBtn').on('click', () => {
  hideResetButton();
  showSpinner();
});
/* eslint-enable strict */
